<ng-container *ngIf="notExecutedHistoryItemObject == null; else modalContent">
  <mat-spinner class="load-spinner" color="primary" diameter="75"></mat-spinner>
</ng-container>
<ng-template #modalContent>
  <h2 class="under-space">Niet uitgevoerde opdracht</h2>

  <div class="more-upper-space">
    <textarea-input
      [initContent]="notExecutedHistoryItemObject.content"
      [subtitle]="
        'Reden: noteer waarom de opdracht niet uitgevoerd kon worden.'
      "
      [placeholder]="''"
      [disabled]="disabled"
      (answer)="contentChanged($event)"
    ></textarea-input>
  </div>

  <div class="upper-space">
    <div class="d-flex justify-content-between">
      <yes-no
        [subtitle]="'Bellen met Inpress. (03 825 40 16)'"
        [value]="notExecutedHistoryItemObject.callInpress"
        [neverShowExtraInstructions]="true"
        [nullIsFalse]="false"
        [disabled]="disabled"
        (answer)="setCallInpress($event)"
      ></yes-no>
      <span
        class="mt-auto mb-auto font-italic"
        *ngIf="!!notExecutedHistoryItemObject.inpressCommunicationRegistration"
      >
        ({{
          notExecutedHistoryItemObject.inpressCommunicationRegistration.by
            ?.firstName
            | personName
              : notExecutedHistoryItemObject.inpressCommunicationRegistration.by
                  ?.lastName
        }},
        {{
          notExecutedHistoryItemObject.inpressCommunicationRegistration.date
            | date : 'dd/MM/yyyy HH:mm'
        }})
      </span>
    </div>

    <textarea-input
      *ngIf="notExecutedHistoryItemObject.callInpress"
      [initContent]="notExecutedHistoryItemObject.inpressCommunicationSummary"
      [subtitle]="'Met wie heb je gebeld:'"
      [placeholder]="'voornaam naam / telefoonnummer / gsm'"
      [disabled]="disabled"
      (answer)="inpressCommunicationSummaryChanged($event)"
    ></textarea-input>
  </div>

  <div class="upper-space">
    <div class="d-flex justify-content-between">
      <yes-no
        [subtitle]="'Bellen met makelaar.'"
        [value]="notExecutedHistoryItemObject.callClient"
        [neverShowExtraInstructions]="true"
        [nullIsFalse]="false"
        [disabled]="disabled"
        (answer)="setCallClient($event)"
      ></yes-no>
      <span
        class="mt-auto mb-auto font-italic"
        *ngIf="!!notExecutedHistoryItemObject.clientCommunicationRegistration"
      >
        ({{
          notExecutedHistoryItemObject.clientCommunicationRegistration.by
            ?.firstName
            | personName
              : notExecutedHistoryItemObject.clientCommunicationRegistration.by
                  ?.lastName
        }},
        {{
          notExecutedHistoryItemObject.clientCommunicationRegistration.date
            | date : 'dd/MM/yyyy HH:mm'
        }})
      </span>
    </div>

    <textarea-input
      *ngIf="notExecutedHistoryItemObject.callClient"
      [initContent]="notExecutedHistoryItemObject.clientCommunicationSummary"
      [subtitle]="'Met wie heb je gebeld:'"
      [placeholder]="'voornaam naam / telefoonnummer / gsm'"
      [disabled]="disabled"
      (answer)="clientCommunicationSummaryChanged($event)"
    ></textarea-input>
  </div>

  <div class="upper-space">
    <textarea-input
      [initContent]="notExecutedHistoryItemObject.suggestedFollowUp"
      [subtitle]="'Wat moet er gebeuren of wat werd er verder afgesproken.'"
      [placeholder]="''"
      [disabled]="disabled"
      (answer)="suggestedFollowUpChanged($event)"
    ></textarea-input>
  </div>

  <div *ngIf="subProject.type !== 'Repo'" class="upper-space">
    <yes-no
      [subtitle]="stockedAtBranchSubtitle"
      [value]="stockedAtBranch"
      [neverShowExtraInstructions]="true"
      [nullIsFalse]="false"
      [disabled]="disabled"
      (answer)="setStockedAtBranch($event)"
    ></yes-no>

    <ng-container *ngIf="stockedAtBranch">
      <div class="d-flex less-top-space">
        <div [class.branch-choices-loaded]="branchChoices?.length > 0">
          Waar: duid het filiaal aan:
        </div>
        <div class="left-space">
          <ng-container *ngIf="branchChoices?.length > 0; else showSpinner">
            <mat-form-field class="" appearance="outline">
              <mat-select
                matInput
                placeholder="Filiaal"
                [disabled]="disabled"
                [(ngModel)]="notExecutedHistoryItemObject.stockAtBranchId"
              >
                <mat-option
                  *ngFor="let option of branchChoices"
                  [value]="option.id"
                >
                  {{ option.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </ng-container>
          <ng-template #showSpinner>
            <mat-spinner color="primary" diameter="24"></mat-spinner>
          </ng-template>
        </div>
      </div>
    </ng-container>
  </div>

  <immo-ip-placer-tour-item-detail-not-executed-assets
    [notExecutedHistoryItemObject]="notExecutedHistoryItemObject"
    [subProject]="subProject"
    [immoIPPlacerTourItemDetailChangeStorageHandler]="
      immoIPPlacerTourItemDetailChangeStorageHandler
    "
    (addedAssetUuids)="addedAssetUuidsChanged($event)"
  ></immo-ip-placer-tour-item-detail-not-executed-assets>

  <div class="upper-space button-container">
    <button
      class="save-button"
      mat-button
      type="button"
      [disabled]="
        disabled ||
        notExecutedHistoryItemObject.content?.length <= 0 ||
        notExecutedHistoryItemObject.callInpress == null ||
        notExecutedHistoryItemObject.callClient == null ||
        (stockedAtBranch == null &&
          subProject.type !== SUB_PROJECT_TYPES.REPO) ||
        (stockedAtBranch &&
          notExecutedHistoryItemObject.stockAtBranchId == null) ||
        (subProject.type === SUB_PROJECT_TYPES.BASE_PROJECT &&
          notExecutedHistoryItemObject?.assets?.length <= 0 &&
          notExecutedHistoryItemObject?.offlineAssets?.length <= 0)
      "
      (click)="submitNotExecuted()"
    >
      <span
        [matTooltip]="
          notExecutedHistoryItemObject.content?.length <= 0
            ? 'Reden mag niet leeg zijn'
            : notExecutedHistoryItemObject.callInpress == null
            ? 'Bellen met Inpress mag niet null zijn'
            : notExecutedHistoryItemObject.callClient == null
            ? 'Bellen met klant mag niet null zijn'
            : stockedAtBranch == null &&
              subProject.type !== SUB_PROJECT_TYPES.REPO
            ? 'Werd bord uitgesteld mag niet null zijn'
            : stockedAtBranch &&
              notExecutedHistoryItemObject.stockAtBranchId == null
            ? 'Filiaal mag niet null zijn'
            : subProject.type === SUB_PROJECT_TYPES.BASE_PROJECT &&
              notExecutedHistoryItemObject?.assets?.length <= 0 &&
              notExecutedHistoryItemObject?.offlineAssets?.length <= 0
            ? 'Er moet minstens één foto toegevoegd zijn'
            : ''
        "
        [matTooltipDisabled]="
          !(
            notExecutedHistoryItemObject.content?.length <= 0 ||
            notExecutedHistoryItemObject.callInpress == null ||
            notExecutedHistoryItemObject.callClient == null ||
            (stockedAtBranch == null &&
              subProject.type !== SUB_PROJECT_TYPES.REPO) ||
            (stockedAtBranch &&
              notExecutedHistoryItemObject.stockAtBranchId == null) ||
            (subProject.type === SUB_PROJECT_TYPES.BASE_PROJECT &&
              notExecutedHistoryItemObject?.assets?.length <= 0 &&
              notExecutedHistoryItemObject?.offlineAssets?.length <= 0)
          )
        "
        >Opslaan</span
      >
    </button>
  </div>
</ng-template>
